import { Link } from "react-router-dom";
import "./ArticleCard.css";

function ArticleCard(props) {
  const stripped = props.article.replace(/<[^>]*>/g, "");
  const limitedData = stripped.substring(0, 160);
  const formattedDate = props.date
    ? new Date(props.date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  return (
    <article className="articleCard">
      <Link to={`/blog/${props.slug || props.id}`} className="articleCardLink">
        {props.image && (
          <div className="articleCardImage">
            <img src={props.image} alt={props.title} />
          </div>
        )}
        <div className="articleCardBody">
          <div className="articleCardMeta">
            <span>{formattedDate}</span>
            <span className="articleCardDot">•</span>
            <span>{props.author || "SoloChat"}</span>
          </div>
          <h2>{props.title}</h2>
          <p>{limitedData}...</p>
          <span className="articleCardRead">Continue reading</span>
        </div>
      </Link>
    </article>
  );
}

export default ArticleCard;
